import {CHART__STATE_UPDATED} from 'app/AppConstants';

export const updateChartState = (urn, state) => ({
  type: CHART__STATE_UPDATED,
  payload: {
    urn,
    state,
  },
});
